<div class="wrapper">
    <div class="bg"
        [style.backgroundColor]="color"></div>
    <span [style.color]="color">{{text}}</span>
    <svg-icon *ngIf="showRemoveIcon"
        [svgClass]="'remove-label'"
     
        (click)="unassign()"
        src="assets/images/icon-menu-close.svg"></svg-icon>
</div>